let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("knuQ3")).then(() => parcelRequire('8m4Cb'));